import {z} from "zod";

import {refineVehicleCommonFields, vehicleObjectSchema} from "../../safelistings/schemas";
import {VEHICLE_IDENTITY_REQUIRED_MESSAGE} from "../lib/vehicle-identity";

export const vehicleFormSchema = vehicleObjectSchema
  .extend({
    secondary_plate: z.string().max(64).optional(),
    vin: z.string().max(64).optional(),
    has_dealers_plate: z.boolean().optional(),
    vehicle_make_id: z.number().nullish(),
    vehicle_model_id: z.number().nullish(),
  })
  .superRefine(refineVehicleCommonFields)
  .superRefine((data, ctx) => {
    const plate = data.plate?.trim() ?? "";
    const vin = data.vin?.trim() ?? "";
    if (!plate && !vin) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: VEHICLE_IDENTITY_REQUIRED_MESSAGE,
        path: ["plate"],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: VEHICLE_IDENTITY_REQUIRED_MESSAGE,
        path: ["vin"],
      });
    }
  })
  .superRefine((data, ctx) => {
    const secondary = data.secondary_plate?.trim() ?? "";
    if (!secondary) return;
    const primary = data.plate?.trim() ?? "";
    if (!primary) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Enter a license plate before adding a secondary plate.",
        path: ["secondary_plate"],
      });
      return;
    }
    if (secondary.toUpperCase() === primary.toUpperCase()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Secondary plate must differ from the license plate.",
        path: ["secondary_plate"],
      });
    }
  })
  .superRefine((data, ctx) => {
    const makeId = data.vehicle_make_id;
    const modelId = data.vehicle_model_id;
    const hasMake = makeId != null && Number.isFinite(makeId);
    const hasModel = modelId != null && Number.isFinite(modelId);
    // Allowed: both IDs, neither ID, or catalog make + manual model (make id only).
    if (hasModel && !hasMake) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Select a catalog make before choosing a catalog model.",
        path: ["model"],
      });
    }
  });
